import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=86d7678e&scoped=true&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"
import style0 from "./Discord.vue?vue&type=style&index=0&id=86d7678e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d7678e",
  null
  
)

component.options.__file = "Discord.vue"
export default component.exports